import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is responsive web design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Responsive web design ensures that a website looks and functions well on all screen sizes, including desktops, tablets, and smartphones."
      }
    },
    {
      "@type": "Question",
      "name": "Why is responsive design important?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It improves user experience, boosts SEO rankings, and ensures accessibility across devices, which is essential in today’s mobile-first world."
      }
    },
    {
      "@type": "Question",
      "name": "Do responsive websites rank better on Google?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Google prioritizes mobile-friendly and responsive websites in search results, especially for mobile users."
      }
    },
    {
      "@type": "Question",
      "name": "Can you redesign my existing website to be responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can audit and redesign your current website to make it fully responsive without compromising its structure or content."
      }
    },
    {
      "@type": "Question",
      "name": "Do you follow mobile-first design practices?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I design layouts that prioritize mobile usability first, then scale up for larger screens."
      }
    },
    {
      "@type": "Question",
      "name": "What devices will my responsive website support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Your website will be optimized for phones, tablets, laptops, desktops, and even large smart TVs or ultra-wide monitors."
      }
    },
    {
      "@type": "Question",
      "name": "Will the layout adjust automatically?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. The design uses CSS media queries and flexible grids to automatically adjust layout, images, and text according to screen size."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a responsive website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Typically, a responsive website takes 5–10 business days depending on the number of pages and complexity."
      }
    },
    {
      "@type": "Question",
      "name": "Do responsive designs work with WordPress?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I build responsive themes or customize your existing WordPress theme to ensure full responsiveness."
      }
    },
    {
      "@type": "Question",
      "name": "Can I see design previews for different devices?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I provide mobile, tablet, and desktop previews during the design phase so you can see exactly how your site will look."
      }
    },
    {
      "@type": "Question",
      "name": "What makes your responsive design different?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I create clean, fast-loading designs with focus on UX, SEO, and performance — without bloated code or template restrictions."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Responsive Web Design Services in Gurgaon | Mobile-First Website Design by Pankaj</title>

<meta name="description" content="Get fully responsive, mobile-friendly websites that adapt to all screen sizes. Expert web design services by freelance developer Pankaj in Gurgaon." />

<meta name="keywords" content="responsive web design gurgaon, mobile friendly website design, freelance responsive designer, website redesign for mobile, device adaptive website, responsive website expert india, cross-device website design, mobile-first web development, UX responsive layout, Pankaj Singh web design" />

<meta property="og:title" content="Responsive Web Design Services in Gurgaon | Mobile-First Website Design by Pankaj" />
<meta property="og:description" content="Custom responsive website designs that work on mobile, tablet, and desktop. Designed by Pankaj, freelance web designer in Gurgaon." />
<meta property="og:site_name" content="Pankaj | Freelance Web Designer & Developer" />
<meta property="og:url" content="https://www.pankj.com/responsive-design" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Responsive Web Design Services in Gurgaon | Mobile-First Website Design by Pankaj" />
<meta name="twitter:description" content="Improve user experience and SEO with responsive websites designed by a full-stack freelance developer in India." />

<link rel="canonical" href="https://www.pankj.com/responsive-design" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">Responsive Design</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">
 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Responsive Design</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<div class="hero-section text-center">
  <p>Get Mobile-First, Device-Responsive Website Designs That Adapt Seamlessly to All Screens</p>
  <a href="/contact" class="btn btn-primary mt-3">Request Free Website Audit</a>
</div>

<div class="intro-section py-5">
  <h2>What Is Responsive Web Design?</h2>
  <p>Responsive web design ensures that your website adjusts automatically to fit any screen size — from mobile phones and tablets to laptops and desktops. It improves user experience, boosts your search engine rankings, and ensures your business is accessible to everyone, everywhere.</p>
  <p>As a freelance web designer in Gurgaon, I build fully responsive websites that are fast, clean, and mobile-optimized — with no compromise on design or performance.</p>
</div>

<div class="services-section py-5">
  <h2>What’s Included in My Responsive Design Services</h2>
  <ul>
    <li>✅ Mobile-first web design and development</li>
    <li>✅ Cross-browser and cross-device compatibility</li>
    <li>✅ Flexible grid layouts and media queries</li>
    <li>✅ Optimized navigation for small screens</li>
    <li>✅ Google Core Web Vitals & SEO best practices</li>
    <li>✅ Custom layout design using Figma, XD, or PSD</li>
    <li>✅ Responsive redesign of existing static or outdated websites</li>
    <li>✅ Integration with WordPress, React, or PHP as needed</li>
  </ul>
</div>

<div class="why-choose-me py-5">
  <h2>Why Choose Me for Responsive Web Design?</h2>
  <p>✔ 11+ Years of Full-Stack Web Development Experience</p>
  <p>✔ Custom Design – No Templates or Page Builders</p>
  <p>✔ Direct 1-on-1 Communication and Quick Turnaround</p>
  <p>✔ Pixel-Perfect Layouts Optimized for All Devices</p>
  <p>✔ Freelance Pricing – Without Agency Overhead</p>
</div>

<div class="faq-section py-5">
  <h2>Frequently Asked Questions</h2>

  <div class="faq-item">
    <h3>Will my existing website be made mobile-friendly?</h3>
    <p>Yes. I can convert your existing desktop-only or static site into a modern, responsive layout that adapts to phones and tablets.</p>
  </div>

  <div class="faq-item">
    <h3>Is responsive design important for SEO?</h3>
    <p>Absolutely. Google gives preference to mobile-friendly websites in search results. Responsive design improves ranking, loading speed, and bounce rate.</p>
  </div>

  <div class="faq-item">
    <h3>What devices will my site support?</h3>
    <p>Your site will adapt to all devices — including smartphones, iPads, laptops, desktops, and even large screens or TVs.</p>
  </div>

  <div class="faq-item">
    <h3>How long does it take to deliver a responsive website?</h3>
    <p>Typically, 5–10 business days depending on design complexity and number of pages.</p>
  </div>

  <div class="faq-item">
    <h3>Do you use Bootstrap or Tailwind CSS?</h3>
    <p>Yes. I can build using Bootstrap, Tailwind CSS, or custom responsive frameworks — based on your preference or project needs.</p>
  </div>
</div>

<div class="cta-section py-5 text-center">
  <h2>Start Building a Mobile-Friendly Website Today</h2>
  <p>Let’s create a fully responsive, fast-loading website that works everywhere and converts more visitors.</p>
  <a href="/contact" class="btn btn-success mt-3">Request Free Consultation</a>
</div>

          </div>

        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
